module.exports = __webpack_public_path__ + "static/media/othl-logo-white.826214eb.svg";